<script>
  import GraficoRegione from './GraficoRegione.svelte';
  // import VirtualList from '@sveltejs/svelte-virtual-list';
  import AutoComplete from "simple-svelte-autocomplete";

  import { dataRegioni } from './stores/data-regioni.store.js';
  
  export let regione = "Toscana";
  let start;
	let end;
  $: regioni = [
     ...new Set($dataRegioni.map(entry => entry.denominazione_regione))
  ];


</script>

<!-- <div class='container mx-auto max-w-none h-screen max-h-full '>
	<VirtualList items={regioni} bind:start bind:end let:item>
		<GraficoRegione regione={item}/>
	</VirtualList>
</div> -->
<!-- {#each regioni as regione} -->

<GraficoRegione bind:regione={regione}>
	<AutoComplete items={regioni} bind:selectedItem={regione} className="text-gray-700" placeholder="regione"/>
</GraficoRegione>
<!-- {/each} -->